import { Course } from "interfaces/courses";
import { FC } from "react";
import styles from './RelatedCourses.module.scss';
import { useTranslation } from "next-i18next";
import CourseGrid from "../courses-list/course-grid/CourseGrid";

interface RelatedCoursesProps {
  courses: Course[]
}

const RelatedCourses:FC<RelatedCoursesProps> = ({courses}) => {
  const { t } = useTranslation("courses")
  
  if (courses.length == 0) return (<></>)

  return (
    <div className={styles.container}>
      <h3 className={styles.h2}>
        {t("related-courses")}
      </h3>
      <CourseGrid courses={courses} />
    </div>
  )
}

export default RelatedCourses;